<template>
    <div
        id="app"
        @contextmenu.stop.prevent=""
    >
        <router-view />
    </div>
</template>

<style lang="scss" src="./stylesheets/app.scss"></style>

<script>
export default {
    name: 'app',
    data() {
        return {};
    },
    methods: {
        // goHome(){
        //   window.location.href = "/"
        // },
        // autoSave(){
        //   //do nothing
        // },
        // saveTemplate() {
        //   // if(this.$route.meta.type==='slider'){
        //   //   this.$store.commit('generate_schema')
        //   //   this.$store.dispatch('schema/create', {
        //   //     data:{
        //   //       name:"form",
        //   //       scene:this.$route.params.id,
        //   //       fields:this.$store.state.schema
        //   //     }
        //   //   })
        //   //   Axios.patch(`/scene/${this.$route.params.id}`, {
        //   //     content: this.scene
        //   //   }).then(() => {
        //   //     notification.success('保存成功')
        //   //   })
        //   // }else{
        //   //   Axios.patch(`/poster/${this.$route.params.id}`, {
        //   //     content: this.scene.pages[0]
        //   //   }).then(() => {
        //   //     notification.success('保存成功')
        //   //   })
        //   // }
        // },
        // onKeyRelease(e) {
        //   if (e.key === 'Meta' || e.key === 'Shift') {
        //     this.$store.commit('input/keyup')
        //   }
        // },
        //       close() {
        //         this.$confirm('退出后关闭编辑器', '是否保存内容', {
        //           customClass: 'confirm',
        //           confirmButtonText: '保存',
        //           cancelButtonText: '不保存',
        // //          showClose:true,
        //           type: 'warning'
        //         }).then(() => {
        //           Axios.patch(`/scene/${this.$route.params.id}`, {
        //             content: this.scene
        //           }).then(() => {
        //             window.postMessage('close','*')
        //             window.location.href = '/center/myworks'
        //           })
        //         }, (r) => {
        //           window.postMessage('close','*')
        //           window.location.href = '/center/myworks'
        //         }).catch(() => {
        //         });
        //       },
        // showShareModal() {
        //   this.$store.commit('open_share_modal')
        // }
    }
};
</script>
